/**
 * @enum {String}
 */

import {Reducers} from './dataEnum';

// eslint-disable-next-line import/prefer-default-export
export const DeviceActionType = {
  WIFI_STATUS: `${Reducers.DEVICE_STORE}/WIFI_STATUS`,
  POWER: `${Reducers.DEVICE_STORE}/POWER`,
  TIMEZONE: `${Reducers.DEVICE_STORE}/TIMEZONE`,
  USER_SELECTED_TIMEZONE: `${Reducers.DEVICE_STORE}/USER_SELECTED_TIMEZONE`,
  USER_SELECTED_DATE: `${Reducers.DEVICE_STORE}/USER_SELECTED_DATE`,
  USER_SELECTED_TIME: `${Reducers.DEVICE_STORE}/USER_SELECTED_TIME`,
  ORIGIN_TIMEZONE: `${Reducers.DEVICE_STORE}/ORIGIN_TIMEZONE`,
  TIMEZONE_CHANGED: `${Reducers.DEVICE_STORE}/TIMEZONE_CHANGED`,
  DATETIME_CHANGED: `${Reducers.DEVICE_STORE}/DATETIME_CHANGED`,
  EDIT_TIMEZONE_SETTING: `${Reducers.DEVICE_STORE}/EDIT_TIMEZONE_SETTING`,
  SET_TIMEZONE_OPTION: `${Reducers.DEVICE_STORE}/SET_TIMEZONE_OPTION`,
  SET_TIMEZONE_OPTION_MANUAL: `${Reducers.DEVICE_STORE}/SET_TIMEZONE_OPTION_MANUAL`,
  SET_TIMEZONE_OPTION_MANUAL_ORIGINAL: `${Reducers.DEVICE_STORE}/SET_TIMEZONE_OPTION_MANUAL_ORIGINAL`,
};
